
import IseecooSlideShow from '@/components/iseecoo-slideshow'
import ProductSpecificationSwiper from '@/components/product-specification-swiper'
import 'vite/modulepreload-polyfill'

const initCustomElements = () => {
    if (!window.customElements.get('iseecoo-product-specification-swiper')) {
        window.customElements.define('iseecoo-product-specification-swiper', ProductSpecificationSwiper)
    }
    if(!window.customElements.get('iseecoo-slide-show')){
      window.customElements.define('iseecoo-slide-show', IseecooSlideShow)
    }
}

initCustomElements()